module.exports = __webpack_public_path__ + "static/media/orangeMapIcon.a589d89b.svg";